import { makeApiActionCreatorV3 } from '@actions/utils';

import * as api from '../api/documentUpload';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';

const prefix = 'ASSESSMENT';

export const FETCH_DOCUMENT_UPLOADS = createRequestTypes(
  `${prefix}/FETCH_DOCUMENT_UPLOADS`,
);

export const fetchDocumentUploads = makeApiActionCreatorV3(
  api.fetchDocumentUploads,
  FETCH_DOCUMENT_UPLOADS[START],
  FETCH_DOCUMENT_UPLOADS[SUCCESS],
  FETCH_DOCUMENT_UPLOADS[ERROR],
);

export const FETCH_DOCUMENT_UPLOAD_ERRORS = createRequestTypes(
  `${prefix}/FETCH_DOCUMENT_UPLOAD_ERRORS`,
);

export const fetchDocumentUploadErrors = makeApiActionCreatorV3(
  api.fetchDocumentUploadErrors,
  FETCH_DOCUMENT_UPLOAD_ERRORS[START],
  FETCH_DOCUMENT_UPLOAD_ERRORS[SUCCESS],
  FETCH_DOCUMENT_UPLOAD_ERRORS[ERROR],
);

export const UPLOAD_DOCUMENT = createRequestTypes(`${prefix}/UPLOAD_DOCUMENT`);

export const uploadDocument = makeApiActionCreatorV3(
  api.uploadDocument,
  UPLOAD_DOCUMENT[START],
  UPLOAD_DOCUMENT[SUCCESS],
  UPLOAD_DOCUMENT[ERROR],
);

export const DOCUMENT_UPLOAD_START_RUN = createRequestTypes(
  `${prefix}/DOCUMENT_UPLOAD_START_RUN`,
);

export const documentUploadStartRun = makeApiActionCreatorV3(
  api.documentUploadStartRun,
  DOCUMENT_UPLOAD_START_RUN[START],
  DOCUMENT_UPLOAD_START_RUN[SUCCESS],
  DOCUMENT_UPLOAD_START_RUN[ERROR],
);
